import { Icon } from '@platform/components';
import dataTestids from '../constants/test-ids';

const LinkedInButton = () => {
  return (
    <a
      className='text-gray-500 hover:text-black'
      href='https://www.linkedin.com/company/movingworlds/mycompany/'
      data-testid={dataTestids.LAYOUT.FOOTER.LINKED_IN}
      target='_blank'
      rel='noreferrer'
    >
      <Icon type='linked-in' size='40' viewbox='0 0 32 32' />
    </a>
  );
};

export default LinkedInButton;
